/**
 * StatCard — small numerical tile used in the dashboard stats grid on
 * both the Adviser and Assistant views (CLAUDE.md §21).
 *
 * The icon tint is `color-mix(in srgb, <color> 8%, transparent)` — the
 * same ~8% tint the old `${color}14` hex-alpha suffix produced, but it
 * also accepts CSS variables, so callers can pass `var(--cp-*)` tokens.
 */

import React from 'react';
import { motion } from 'framer-motion';

export default function StatCard({ label, value, icon: Icon, color }) {
  return (
    <motion.div className="card" style={styles.statCard} whileHover={{ y: -2 }}>
      <div style={{ ...styles.statIcon, background: `color-mix(in srgb, ${color} 8%, transparent)`, color }}>
        <Icon size={18} />
      </div>
      <div>
        <div style={styles.statValue}>{value}</div>
        <div style={styles.statLabel}>{label}</div>
      </div>
    </motion.div>
  );
}

const styles = {
  statCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    padding: '1rem 1.25rem',
  },
  statIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    borderRadius: '10px',
    flexShrink: 0,
  },
  statValue: {
    fontSize: '1.3rem',
    fontWeight: 700,
    color: 'var(--cp-text)',
    lineHeight: 1.2,
  },
  statLabel: {
    fontSize: '0.75rem',
    color: '#6B7A8D',
    fontWeight: 500,
  },
};
